import React, {MouseEventHandler} from 'react';

interface ConfirmButtonProps {
	show?: boolean;
	text?: string;
	disabled?: boolean;
	onclick: MouseEventHandler<HTMLButtonElement>;
}

const ConfirmButton = ({show = true, text = 'Confirm', disabled = false, onclick}: ConfirmButtonProps) => {
	if (!show) return null;

	return (
		<button
			className={`flex h-[36px] px-[16px] mt-2 items-center rounded-[4px] bg-primary text-white font-semibold`}
			disabled={disabled}
			onClick={onclick}>{text}</button>
	);
};

export default ConfirmButton;
